// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import printJS from 'print-js'
require("packs/maskMoney")
require('inputmask')

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import * as bootstrap from 'bootstrap'

document.addEventListener('DOMContentLoaded', function (event) {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
})

window.money = function() {
  $('.currency').maskMoney({thousands:'.', decimal:',', affixesStay: false});
}

window.loadButton = function(btn, cost) {
  if(cost != '') {
    btn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
    var new_class = btn.getAttribute('class')
    new_class += ' disabled'
    btn.setAttribute('class', new_class)
  }
}

window.setLoad = function() {
  $('#main-container').removeClass('d-none')
}

window.printTicketJS = function(selector) {
  printJS({
    printable: selector,
    type: 'html',
    scanStyles: true,
    targetStyles: ['*'],
    style: '.ticket { display: block !important; }',
    documentTitle: 'Comprovante',
    showModal: true,
    modalMessage: 'Preparando para imprimir...',
    modal: false
  });
}

window.printOS = function() {
  var selectedItems = $('#selected_items_list');
  selectedItems.empty(); // Limpa a lista de itens selecionados

  // Itera sobre todos os checkboxes de item que estão marcados
  $('.item_checkbox:checked').each(function() {
    var itemName = $(this).data('name');
    var itemAmount = $(this).data('amount');
    var itemInfo = $(this).data('info');
    var itemHtml = '<p>' + '- ' + itemName + ' - ' + itemAmount + 'un';
    if (itemInfo !== undefined && itemInfo !== null && itemInfo !== '') {
      itemHtml += ' * ' + itemInfo;
    }
    itemHtml += '</p>';

    selectedItems.append(itemHtml);
  });

  printTicketJS('printableserviceorder');
}

$(document).on('turbolinks:load', function () {
  var cpfMask = new Inputmask('999.999.999-99');
  var birthdateMask = new Inputmask('99/99/9999');
  var phoneMask = new Inputmask('(99) 99999-9999');
  var cardMask = new Inputmask('9999 9999 9999 9999');
  var expDateMask = new Inputmask('99/99');
  var securityMask = new Inputmask('999');

  var documentSelector = $('#person_document');
  var birthdateSelector = $('#user_birth_date');
  var phoneSelector = $('#user_phone');
  var customerPhoneSelector = $('#customer_phone');
  var customerOutPhoneSelector = $('#_customer_phone');
  var cardSelector = $('#card_number');
  var expDateSelector = $('#expiration_date');
  var securitySelector = $('#security_code');

  cardMask.mask(cardSelector);
  expDateMask.mask(expDateSelector);
  securityMask.mask(securitySelector);
  cpfMask.mask(documentSelector);
  birthdateMask.mask(birthdateSelector);
  phoneMask.mask(phoneSelector);
  phoneMask.mask(customerPhoneSelector);
  phoneMask.mask(customerOutPhoneSelector);

  $('[data-toggle="tooltip"]').tooltip();

  $('.copy-location').on('click', function() {
    var location = $(this).data('location');

    var $tempInput = $('<input>');
    $('body').append($tempInput);
    $tempInput.val(location).select();
    document.execCommand('copy');
    $tempInput.remove();

    var $icon = $(this);
    $icon.tooltip('dispose');
    $icon.attr('title', 'Copiado!');
    $icon.tooltip('show');

    setTimeout(function() {
      $icon.tooltip('hide');
      $icon.tooltip('dispose');
      $icon.attr('title', 'Copiar localização');
      $icon.tooltip();
    }, 2000);
  });
});
